import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { staticClass: "pa-4", attrs: { flat: "", outlined: "" } },
    [
      _c(
        VCardTitle,
        { staticClass: "subtitle-1 primary--text pa-0 ma-0" },
        [_c("span", [_vm._v(_vm._s(_vm.titulo.toUpperCase()))])]
      ),
      _c(
        VCardText,
        { staticClass: "pa-0 ma-0" },
        [
          _c(VDataTable, {
            attrs: {
              items: [_vm.value],
              headers: _vm.value.headers,
              "hide-default-footer": "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }